import { IconProps } from 'components/icons/Icons.types';
import React from 'react';
import styles from './Icon.module.scss';

const GamesIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = '#fffff0',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />
        <path
          d="M13.83 10.91c.27.27.27.71 0 .98-.27.28-.72.28-.99 0-.27-.27-.27-.71 0-.98.27-.28.72-.28.99 0Z"
          fill={color}
        />
        <path
          d="M14.32 9.42c.28-.27.72-.27.99 0 .28.27.28.72 0 .99-.27.27-.71.27-.99 0-.27-.27-.27-.72 0-.99Z"
          fill={color}
        />
        <path
          d="M16.8 10.91c.27.27.27.71 0 .98-.27.28-.72.28-.99 0-.27-.27-.27-.71 0-.98.27-.28.72-.28.99 0Z"
          fill={color}
        />
        <path
          d="M14.32 12.39c.28-.27.72-.27.99 0 .28.27.28.72 0 .99-.27.27-.71.27-.99 0-.27-.27-.27-.72 0-.99Z"
          fill={color}
        />
        <path d="M7.2 12.1H5.8V10.7H7.2V9.3H8.6v1.4H10v1.4H8.6v1.4H7.2V12.1Z" fill={color} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.4 7C5.69 7 3.5 9.19 3.5 11.9c0 2.71 2.19 4.9 4.9 4.9h7c2.71 0 4.9-2.19 4.9-4.9 0-2.71-2.19-4.9-4.9-4.9h-7Zm7 1.4h-7c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5h7c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default GamesIcon;
